import { render, staticRenderFns } from "./selectCommodity.vue?vue&type=template&id=3c15e8fd&scoped=true"
import script from "./selectCommodity.vue?vue&type=script&lang=js"
export * from "./selectCommodity.vue?vue&type=script&lang=js"
import style0 from "./selectCommodity.vue?vue&type=style&index=0&id=3c15e8fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c15e8fd",
  null
  
)

export default component.exports